import { createAppSlice } from './createAppSlice';
import type { PayloadAction } from '@reduxjs/toolkit';

export interface ConflictingModalType {
  open: boolean;
  items: Array<any>; // Actually Array<AxfoodCartEntryStatusViewModel>
  storeId?: string;
  reason?: string;
}

const initialState: ConflictingModalType = {
  open: false,
  items: [],
  storeId: undefined,
  reason: '',
};

export const conflictingModalSlice = createAppSlice({
  name: 'conflictingModal',
  initialState,
  reducers: (create) => ({
    openConflictingModal: create.reducer((state, action: PayloadAction<{ open: boolean; reason?: string }>) => {
      state.open = action.payload.open;
      state.reason = action.payload.reason;
    }),
    setConflictingModalStoreId: create.reducer((state, action: PayloadAction<string>) => {
      state.storeId = action.payload;
    }),
    setItemsConflictingModal: create.reducer((state, action: PayloadAction<Array<any>>) => {
      state.items = action.payload;
    }),
    resetConflictingModal: create.reducer(() => {
      return initialState;
    }),
  }),
  selectors: {
    selectConflictingModal: (modal) => modal,
  },
});

export const { openConflictingModal, setConflictingModalStoreId, setItemsConflictingModal, resetConflictingModal } =
  conflictingModalSlice.actions;

export const { selectConflictingModal } = conflictingModalSlice.selectors;
